var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRectangle = function SvgRectangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.753
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fill: "#A8A8A8",
    d: "M8.608 14.052l-7.171-2.035v6.6l6.886 3.031a1 1 0 0 0 .893-.044l14.34-8.075a1 1 0 0 0 .51-.87V8.466a1 1 0 0 0-1.435-.9L9.315 13.99a1 1 0 0 1-.707.061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.804 11.64l7.638 2.511a.5.5 0 0 0 .384-.03L23.359 7.2a.5.5 0 0 0-.095-.927L12.81 3.38 7.627 5.299a.2.2 0 0 0 .008.378l4.528 1.454-10.372 3.943a.3.3 0 0 0 .013.565zM1.61 11.792v6.816a.5.5 0 0 0 .33.47l7.303 2.653"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.587 6.794v6.055a.5.5 0 0 1-.241.428l-13.89 8.428"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 7.15v5.4M7.243 5.5v3.277"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRectangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rectangle.5892e598.svg";
export { ForwardRef as ReactComponent };